import { Navigate, useLocation } from "react-router-dom"
import axios from "axios"
import { useState, useEffect, useLayoutEffect  } from "react"
import * as endPoints from '../Constants/Endpoints'

export const useAuth = () => {
    const [isAuth, setIsAuth] = useState(null);
    const location = useLocation();
useLayoutEffect(() => {
    const allowedRoutes = [
        '/',
        '/register',
        '/client-site',
        '/make-a-booking',
        '/booking-payment-result',
        '/success',
        '/choose-plan',
        '/login',
        '/landing-page',
        '/cancel-appointment',
        '/request-forgot-password',
        '/reset-password'
    ];

    if (allowedRoutes.includes(location.pathname)) {
        setIsAuth(false);
        return;
    }
    setIsAuth(null);
    const fetchData = async () => {
        try {
            const res = await axios.get(
                process.env.REACT_APP_API_SERVICE_BASE_URL + endPoints.Authenticated,
                { withCredentials: true }
            );

            setIsAuth(res.status === 200);
        } catch (e) {
            setIsAuth(false);
        }
    };

    fetchData();
}, [location.pathname]);
return isAuth;
}

const ProtectedRoute = ({ children }) => {
    const isAuth = useAuth();
    console.log(isAuth)
    let location = useLocation();
    if (isAuth === null)
        // <Navigate to="/login" />
    return null;
    return isAuth ?
        children :
        location.pathname === '/cancel-appointment' ?
        <Navigate to="/cancel-appointment" /> :
        location.pathname === '/login' ?
        <Navigate to="/login" /> :
        location.pathname === '/request-forgot-password' ?
        <Navigate to="/request-forgot-password" /> :
        location.pathname === '/reset-password' ?
        <Navigate to="/reset-password" /> :
        location.pathname === '/register' ?
        <Navigate to="/register" /> :
        location.pathname === '/make-a-booking' ? 
        <Navigate to="/make-a-booking" /> :
        location.pathname === '/booking-payment-result' ? 
        <Navigate to="/booking-payment-result" /> :
        location.pathname === '/choose-plan' ? 
        <Navigate to="/choose-plan" /> :
        location.pathname === '/success' ? 
        <Navigate to="/success" /> :
        location.pathname === '/client-site' ? 
        <Navigate to="/client-site" /> : 
        location.pathname === '/landing-page' ? 
        <Navigate to="/landing-page" /> :
        <Navigate to="/" />;
};

export default ProtectedRoute;